import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/blogApi';
import { toast } from 'react-toastify';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(form);
      localStorage.setItem('adminToken', res.data.token);
      toast.success('Welcome back, Dennis!');
      navigate('/admin');
    } catch {
      toast.error('Invalid credentials. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0A2540',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.05)', borderRadius: 16,
        border: '1px solid rgba(255,255,255,0.1)', padding: '48px 40px',
        width: '100%', maxWidth: 440,
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: '1.8rem', color: '#fff', marginBottom: 8 }}>
            Dennis<span style={{ color: '#7C4DFF' }}>.</span>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.9rem' }}>Admin Dashboard Login</p>
        </div>

        <form onSubmit={handleSubmit}>
          {['username', 'password'].map(field => (
            <div key={field} style={{ marginBottom: 20 }}>
              <label style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 6 }}>
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </label>
              <input
                type={field === 'password' ? 'password' : 'text'}
                value={form[field]}
                onChange={e => setForm({ ...form, [field]: e.target.value })}
                placeholder={field === 'username' ? 'admin' : '••••••••'}
                required
                style={{
                  width: '100%', padding: '12px 16px', borderRadius: 8,
                  background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
                  color: '#fff', fontSize: '0.95rem', fontFamily: 'inherit', outline: 'none',
                }}
              />
            </div>
          ))}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: '#7C4DFF', color: '#fff',
            border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '1rem',
            cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
            opacity: loading ? 0.7 : 1, marginTop: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}>
            {loading ? <><i className="fas fa-spinner fa-spin" /> Logging in...</> : 'Login to Admin'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <a href="/" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.85rem' }}>← Back to Portfolio</a>
        </div>
      </div>

      <style>{`input::placeholder { color: rgba(255,255,255,0.2) !important; }`}</style>
    </div>
  );
}
